// import pdpQuery from '~layers/app/graphql/pdp.gql'
// import stockQuery from '~/graphql/pdp/stock.gql'
import type {
  AvelonStockResponse,
} from '~layers/app/types/avelon'

export function usePDP(meta: any) {
  const { public: config } = useRuntimeConfig()
  const locale = config.strapiLocale
  const status = 'PUBLISHED'

  const productData = useState('productData', () => null)
  const productError = useState<any>('productError', () => null)
  const stockData = useState('stockData', () => ({}))
  const AvelonStockData = useState<AvelonStockResponse | object>('AvelonStockData', () => ({}))

  const variables = {
    sku: meta.value?.sku,
    locale,
    status,
  }

  async function fetchProductData() {
    // const { data, error } = await useAsyncQuery<any>(pdpQuery, variables)
    const result = await useGraphqlQuery('pdp', variables, useGraphqlDefaultClient())

    if (!result.data) {
      return
    }

    productData.value = result.data
    productError.value = result.errors
  }

  const pdpUsps = computed(() => {
    return productData?.value?.pdpUsps?.[0]?.Usp || []
  })

  const pdpPromotionPeriod = computed(() => {
    const period = productData?.value?.promotionPeriod || 'normaal'
    if (period === 'normaal') {
      return
    }

    if (
      (period === 'solden' || period === 'koppelverkoop')
      && !(esProduct.value?.isSale && esProduct.value?.discount >= 5)
    ) {
      return
    }

    if (
      (period === 'days')
      && (esProduct.value?.isSale && esProduct.value?.discount >= 5)
    ) {
      return
    }

    return (
      productData?.value?.[
        `pdp${period.charAt(0).toUpperCase() + period.slice(1)}`
      ]?.[0]?.Richtexts?.[0]?.Richtext
    )
  })

  const pdpContact = computed(() => {
    return productData?.value?.pdpContact?.[0] || []
  })

  const pdpDelivery = computed(() => {
    return productData?.value?.pdpDelivery?.[0] || []
  })

  const pdpReturn = computed(() => {
    return productData?.value?.pdpReturn?.[0] || []
  })

  const esProduct = computed(() => {
    return productData?.value?.esProduct
  })

  const m2Product = computed(() => {
    const product = {
      ...(productData?.value?.products?.items?.[0] || {}),
    }
    delete product.categories

    if (product && stockData.value?.products?.items?.[0]?.variants?.length) {
      product.variants = product.variants?.map((variant, index) => ({ ...variant, product: { ...variant.product, ...stockData.value?.products?.items?.[0]?.variants[index]?.product } }))
    }
    if (product && stockData.value?.products?.items?.[0]?.stock_status) {
      product.stockItem = stockData.value?.products?.items?.[0].stockItem
      product.stock_left = stockData.value?.products?.items?.[0].stock_left
      product.stock_status = stockData.value?.products?.items?.[0].stock_status
    }
    // if (product && result?.items && stockData.value?.products?.items?.[0]?.items) {
    //   product.items = result.items.map((item, index) => {
    //     if (stockData.value?.products?.items?.[0]?.items[index]?.product?.variants?.length) {
    //       return {
    //         ...item,
    //         product: {
    //           ...item.product,
    //           ...stockData.value?.products?.items?.[0]?.items[index]?.product,
    //           variants: item.product.variants.map((variant, vIndex) => ({
    //             ...variant,
    //             product: { ...variant.product, ...stockData.value?.products?.items?.[0]?.items[index]?.product.variants[vIndex].product },
    //           })),
    //         },
    //       }
    //     }
    //     if (stockData.value?.products?.items?.[0]?.items[index]?.product?.stock_status) {
    //       return { ...item, product: { ...item.product, ...stockData.value.products.items[0].items[index].product } }
    //     }
    //     return { ...item }
    //   })
    // }
    return product
  })

  // const crosssellProducts = computed(() =>
  //   m2Product.value?.crosssell_products?.map(item => item.product) || [],
  // )

  const upsellProducts = computed(() =>
    m2Product.value?.upsell_products?.map(item => item.product) || [],
  )

  const relatedProducts = computed(() =>
    m2Product.value?.related_products
      ?.map(item => item.product)
      .toSorted((a: any, b: any) => (b?.finalPrice ?? 0) - (a?.finalPrice ?? 0)) || [],
  )

  const looksProducts = computed(() =>
    m2Product.value?.looks_products?.slice(0, 1) || [],
  )

  // const interestingProducts = computed(() =>
  //   m2Product.value?.interesting_products?.map(item => item.product) || [],
  // )

  const categories = computed(() => {
    return [
      ...(productData?.value?.products?.items?.[0]?.categories || []),
    ].filter(item => item.url_path).sort((a: any, b: any) => b.level - a.level).map((category: any) => {
      return {
        ...category,
        url: category.url_path,
        label: category.name,
        level: category.level,
      }
    })
  })

  const parentCategories = computed(() => {
    let parent: any = {}
    const parents: any[] = []

    categories.value.forEach((category) => {
      if (esProduct.value?.outlet === 2) {
        category.level++
        category.url = 'outlet/' + category.url
        category.url_key = 'outlet/' + category.url_key
        category.url_path = 'outlet/' + category.url_path
      }
      if (category.url && (!parent.url || parent.url.startsWith(category.url))) {
        parent = category
        parents.push(category)
      }
    })

    if (esProduct.value?.outlet === 2) {
      parent = {
        label: 'outlet',
        name: 'Outlet',
        url: 'outlet',
        url_key: 'outlet',
        url_path: 'outlet',
        level: 2,
      }
      parents.push(parent)
    }

    return parents
  })

  const attributes = computed<Record<string, string | number | null>>(() => {
    return m2Product.value?.attributeGroups?.reduce((acc: never[], item: never) => {
      return acc.concat(item.attributes)
    }, []).reduce((acc: Record<string, string | number | null>, item: never) => {
      acc[item.code] = item.value
      return acc
    }, {})
  })

  // const {
  //   onResult: onLoadedStockData,
  //   load: loadStockData,
  //   loading: pendingStock,
  // } = useLazyQuery(stockQuery, { sku: meta.value?.sku }, { clientId: 'customer' })

  // onLoadedStockData((result) => {
  //   stockData.value = result.data
  // })

  const pendingStock = ref(false)

  const loadStockData = () => {
    pendingStock.value = true
    useGraphqlQuery('pdp', variables, useGraphqlCustomerClient()).then((result) => {
      stockData.value = result?.data
      pendingStock.value = false
      return result
    })
  }

  const pendingAvelonStock = ref(true)
  const loadAvelonStockData = () => {
    pendingAvelonStock.value = true
    useGraphqlQuery('getAvelonStock', variables, useGraphqlCustomerClient()).then((result: { data?: AvelonStockResponse }) => {
      AvelonStockData.value = result?.data ?? {}
      pendingAvelonStock.value = false
      return result
    })
  }

  return {
    data: productData,
    esProduct,
    m2Product,
    categories,
    parentCategories,
    // productAttributeValue,
    error: productError,
    // crosssellProducts,
    upsellProducts,
    relatedProducts,
    looksProducts,
    // interestingProducts,
    fetchProductData,
    attributes,
    stockData,
    loadStockData,
    pendingStock,
    AvelonStockData,
    loadAvelonStockData,
    pendingAvelonStock,
    pdpUsps,
    pdpContact,
    pdpPromotionPeriod,
    pdpDelivery,
    pdpReturn,
  }
}
